/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { beforeAfterCountSchema } from './beforeAfterCountSchema';
import { itemChangeSubsetSchema } from './itemChangeSubsetSchema';
import { riskSubsetSchema } from './riskSubsetSchema';
import { scenarioImpactSummarySchema } from './scenarioImpactSummarySchema';
import { scheduleDriftSummarySchema } from './scheduleDriftSummarySchema';

export const scenarioImpactSummaryResponseSchema = z.object({
  get assignmentChanges() {
    return itemChangeSubsetSchema;
  },
  get estimateChanges() {
    return itemChangeSubsetSchema;
  },
  get scheduleDrift() {
    return scheduleDriftSummarySchema;
  },
  get stillAtRisk() {
    return riskSubsetSchema;
  },
  get summary() {
    return scenarioImpactSummarySchema;
  },
  get teamsWithoutCapacity() {
    return beforeAfterCountSchema;
  },
  get unassignedItems() {
    return beforeAfterCountSchema;
  },
  get unestimatedItems() {
    return beforeAfterCountSchema;
  },
});
